import Image from "next/image"
import React from "react"

interface MaintenancePageProps {
  mode: `maintenance` | `rebuild`
  message?: string
}

const MaintenancePage: React.FC<MaintenancePageProps> = ({ mode, message }) => {
  const isRebuild = mode === `rebuild`

  const defaultMessages = {
    maintenance: {
      title: `Scheduled Maintenance`,
      description: `WellNow is currently undergoing scheduled maintenance. We will be back shortly.`,
    },
    rebuild: {
      title: `We're Building Something Better`,
      description: `Our site is temporarily offline as we work on exciting upgrades. Thank you for your understanding - we'll be back as soon as possible!`,
    },
  }

  // Defensive check: fallback to maintenance if mode is invalid
  const content = defaultMessages[mode] || defaultMessages.maintenance

  return (
    <div
      className={`flex min-h-screen items-center justify-center bg-gradient-to-br from-primary-50 to-primary-100`}
    >
      <div className={`mx-auto max-w-2xl px-4 sm:px-6 lg:px-8`}>
        <div
          className={`rounded-2xl bg-white p-8 text-center shadow-xl md:p-12`}
        >
          <div className={`mb-8 flex justify-center`}>
            <Image
              src={`/svg/wellnow-logo.svg`}
              alt={`WellNow`}
              width={150}
              height={48}
              priority
            />
          </div>

          <h1 className={`mb-4 text-3xl font-bold text-gray-900 md:text-4xl`}>
            {content.title}
          </h1>

          <p className={`mb-8 text-lg text-gray-600`}>
            {message || content.description}
          </p>

          {isRebuild && (
            <div
              className={`mb-6 rounded-lg border border-primary-200 bg-primary-50 p-6`}
            >
              <p className={`font-medium text-primary-800`}>
                We're working hard to improve your experience with enhanced
                features and better performance.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default MaintenancePage
